import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ProductOffer } from 'v2/interfaces/product';
import productService from 'v2/services/product';

type Payload = {
  productId: number;
  orderByNameAsc?: boolean;
  trashed?: boolean;
};

export function useProductOffers(
  { productId, orderByNameAsc, trashed }: Payload,
  options: Omit<UseQueryOptions<ProductOffer[]>, 'queryKey' | 'queryFn'> = {}
) {
  return useQuery({
    queryKey: ['products', productId, 'offers', { orderByNameAsc, trashed }],
    queryFn: () => productService.getOffers(productId, { order_by_name_asc: orderByNameAsc, trashed }),
    ...options
  });
}
